// Arrow/Enter menu navigation should only fire when the visitor isn't doing
// something else: typing, using browser shortcuts (Alt+Left = Back), or
// interacting with an open overlay or another part of the page.
export function shouldHandleMenuKey(e, container) {
  if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return false;
  const target = e.target;
  if (target === document.body || target === document.documentElement) return true;
  return Boolean(container && container.contains(target));
}
